import {
  GET_ALL_OCCUPANCY_LIST, GET_ALL_OCCUPANCY_LIST_SUCCESS,
  CREATE_OCCUPANCY,
  CREATE_OCCUPANCY_SUCCESS,
  UPDATE_OCCUPANCY,
  UPDATE_OCCUPANCY_SUCCESS,
  GET_OCCUPANCY_BY_ID,
  GET_OCCUPANCY_BY_ID_SUCCESS,
  DELETE_OCCUPANCY,
  GET_OCCUPANCY_MODE_OPTIONS,
  GET_OCCUPANCY_MODE_OPTIONS_SUCCESS
} from '../storeTypes';

export const ActionGetAllOccupancyList = payload => {
  return {
    type: GET_ALL_OCCUPANCY_LIST,
    payload,
  };
};
export const ActionGetAllOccupancyListSuccess = payload => {
  return {
    type: GET_ALL_OCCUPANCY_LIST_SUCCESS,
    payload,
  };
};
export const ActionCreateOccupancy = (payload, callBack) => {
  return {
    type: CREATE_OCCUPANCY,
    payload,
    callBack,
  };
};
export const ActionCreateOccupancySuccess = payload => {
  return {
    type: CREATE_OCCUPANCY_SUCCESS,
    payload,
  };
};
export const ActionUpdateOccupancy = (payload, callBack) => {
  return {
    type: UPDATE_OCCUPANCY,
    payload,
    callBack,
  };
};
export const ActionUpdateOccupancySuccess = payload => {
  return {
    type: UPDATE_OCCUPANCY_SUCCESS,
    payload,
  };
};
export const ActionGetOccupancyByID = (payload, callBack) => {
  return {
    type: GET_OCCUPANCY_BY_ID,
    payload,
    callBack,
  };
};
export const ActionGetOccupancyByIDSuccess = payload => {
  return {
    type: GET_OCCUPANCY_BY_ID_SUCCESS,
    payload,
  };
};
export const ActionDeleteOccupancy = (payload, callBack) => {
  return {
    type: DELETE_OCCUPANCY,
    payload,
    callBack,
  };
};

export const ActionGetOccupancyModeOptions = payload => {
  return {
    type: GET_OCCUPANCY_MODE_OPTIONS,
    payload,
  };
};

export const ActionGetOccupancyModeOptionsSuccess = payload => {
  return {
    type: GET_OCCUPANCY_MODE_OPTIONS_SUCCESS,
    payload,
  };
};